import styled from 'styled-components';
import LogoImage from '../../../assets/images/nav.svg';
import { theme, sizes } from '../../../theme';
import { media } from '../../../utilities/grid';

export const FooterWrapper = styled.section`
  background: ${theme.lightGrey};
`;

export const FooterContent = styled.section`
  max-width: ${sizes.maxWidth};
  margin: 0 auto;
  color: ${theme.bootsBlue};
  padding: 1rem 1rem 8rem;
`;

export const FooterImageWrapper = styled.div`
  padding: 1rem 0;
  width: 100%;
  display: flex;
`;

export const FooterLogo = styled.div`
  width: 6rem;
  height: 3rem;
  ${`background-image: url(${LogoImage})`};
  background-repeat: no-repeat;
  background-size: contain;
`;

export const DetailsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 1rem 0;
`;

export const FooterLinks = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-bottom: 1rem;
  ${media.from.desktop`
    width: 40%;
  `}
`;

export const FooterLinkWrapper = styled.p`
  color: ${theme.textGrey};
  font-size: 18px;
  padding: 0.5rem 0;
`;

export const FooterLink = styled.a`
  color: ${theme.bootsBlue};
  font-weight: bold;
`;

export const FooterDisclaimer = styled.div`
  ${media.from.desktop`
    width: 55%;
  `}
`;

export const FooterDisclaimerItem = styled.p`
  font-size: 14px;
  color: ${theme.textGrey};
  margin-bottom: 1rem;
`;

export const MainHeader = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
`;

export const LogoWrapper = styled.div`
  padding: 1.25rem;
`;

export const LogoSrc = styled.div`
  width: 5rem;
  height: 2.7rem;
  ${`background-image: url(${LogoImage})`};
  background-repeat: no-repeat;
  background-size: contain;
`;

export const MainBanner = styled.div`
  background-color: #cc0033;
  color: white;
  padding: 1.25rem;
  text-align: center;
`;

export const LoaderWrapper = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
  background-color: ${theme.lightGreenBackground};
  span {
    border-width: 5px !important;
  }
`;
